let upsellMutationObserver;

function addObserverForUpsellArrows(upCart) {
  setTimeout(function () {
    try {
      // console.log("Executing addObserverForUpsellArrows...");
      if (!upCart) {
        console.error("addObserverForUpsellArrows: Provided upCart is null or undefined.");
        return;
      }
      const upsellShadowRoot = upCart.shadowRoot;
      if (!upsellShadowRoot) {
        console.error("addObserverForUpsellArrows: No shadowRoot found on upCart.");
        return;
      }
      const upsellCarousel = upsellShadowRoot.querySelector("#up-upsell-carousel");
      const upsellPrevBtn = upsellShadowRoot.querySelector("button.control-prev");
      const upsellNextBtn = upsellShadowRoot.querySelector("button.control-next");
  
      if (!upsellCarousel || !upsellPrevBtn || !upsellNextBtn) {
        console.error("addObserverForUpsellArrows: Required carousel or buttons not found.", {
          upsellCarousel, upsellPrevBtn, upsellNextBtn
        });
        return;
      }
  
      const refreshArrowControls = () => {
        try {
          const upsellItems = upsellCarousel.querySelectorAll("li");
          if (!upsellItems || upsellItems.length === 0) {
            console.warn("refreshArrowControls: No upsell items found.");
            return;
          }
          const currentSelectedIndex = Array.from(upsellItems).findIndex(li =>
            li.classList.contains("selected")
          );
          if (currentSelectedIndex < 0) {
            console.warn("refreshArrowControls: No item is currently selected.");
          }
          // Defensive: Check if buttons exist before setting
          if (upsellPrevBtn) upsellPrevBtn.disabled = currentSelectedIndex === 1;
          if (upsellNextBtn) upsellNextBtn.disabled = currentSelectedIndex === 0;
        } catch (err) {
          console.error("refreshArrowControls: Exception occurred.", err);
        }
      };
  
      // Disconnect existing observer if it exists (make sure variable is declared/accessible)
      if (typeof upsellMutationObserver !== "undefined" && upsellMutationObserver) {
        upsellMutationObserver.disconnect();
      }
  
      // Create a new observer instance (make sure the variable is declared in a suitable scope)
      upsellMutationObserver = new MutationObserver(() => {
        try {
          refreshArrowControls();
        } catch (err) {
          console.error("MutationObserver callback error:", err);
        }
      });
  
      const startObservingUpsellItems = () => {
        try {
          const upsellItems = upsellCarousel.querySelectorAll("li");
          if (!upsellItems || upsellItems.length === 0) {
            console.warn("startObservingUpsellItems: No upsell items to observe.");
            return;
          }
          upsellItems.forEach(item => {
            try {
              upsellMutationObserver.observe(item, {
                attributes: true,
                attributeFilter: ["class"]
              });
            } catch (err) {
              console.error("Error observing upsell item:", item, err);
            }
          });
        } catch (err) {
          console.error("startObservingUpsellItems: Exception occurred.", err);
        }
      };
  
      // Initial setup
      refreshArrowControls();
      startObservingUpsellItems();
    } catch (err) {
      console.error("addObserverForUpsellArrows: Unhandled exception.", err);
    }
  }, 1000);
}


function injectShippingProtectionStyles(shadowRoot) {
  if (!shadowRoot || shadowRoot.getElementById("hide-shipping-protection-qty")) return;
  const style = document.createElement("style");
  style.id = "hide-shipping-protection-qty";
  style.textContent = `
    .upcart-public-component-product-tile:has(a[href*="/products/shipping-protection"]) .upcart-public-component-product-tile__quantity-selector,
    .upcart-internal-component-product-tile:has(a[href*="/products/shipping-protection"]) .upcart-internal-component-product-tile__quantity-selector,
    .upcart-public-component-product-tile:has(a[href*="/products/shipping-protection"]) .upcart-public-component-product-tile__controls,
    .upcart-internal-component-product-tile:has(a[href*="/products/shipping-protection"]) .upcart-internal-component-product-tile__controls {
      display: none !important;
    }
  `;
  shadowRoot.appendChild(style);
}

function injectRewardsMinHeightStyles(shadowRoot) {
  if (!shadowRoot || shadowRoot.getElementById("upcart-rewards-min-height")) return;
  const style = document.createElement("style");
  style.id = "upcart-rewards-min-height";
  // Tier labels are absolutely positioned and overflow this box, reaching 77px
  // from its top — min-height must stay above that or the divider and the first
  // cart item ride up into the labels.
  style.textContent = `
    .upcart-internal-rewards,
    .upcart-public-rewards {
      min-height: 115px !important;
      margin-bottom: 8px !important;
    }
  `;
  shadowRoot.appendChild(style);
}

// Every product tile carries a uniform 28px top padding. On the first visible
// item that padding stacks under the rewards divider and reads as a gap, so trim
// it there only.
//
// The item list is a flex column and UpCart reorders free items to the bottom
// with `order: 98` — so `:first-child` is the free sample, NOT the first visible
// item. Select the first non-free item instead: rule one trims every non-free
// tile, rule two puts 28px back on any non-free tile that has a non-free tile
// before it, leaving only the first one trimmed.
function injectFirstCartItemSpacing(shadowRoot) {
  if (!shadowRoot || shadowRoot.getElementById("upcart-first-item-spacing")) return;
  const style = document.createElement("style");
  style.id = "upcart-first-item-spacing";
  style.textContent = `
    .upcart-internal-cart-item:not(.upcart-item-free) > .upcart-internal-component-product-tile,
    .upcart-public-cart-item:not(.upcart-item-free) > .upcart-public-component-product-tile {
      padding-top: 15px !important;
    }
    .upcart-internal-cart-item:not(.upcart-item-free) ~ .upcart-internal-cart-item:not(.upcart-item-free) > .upcart-internal-component-product-tile,
    .upcart-public-cart-item:not(.upcart-item-free) ~ .upcart-public-cart-item:not(.upcart-item-free) > .upcart-public-component-product-tile {
      padding-top: 28px !important;
    }
  `;
  shadowRoot.appendChild(style);
}

function hideShippingProtectionQtyFallback(shadowRoot) {
  if (!shadowRoot) return;
  const tiles = shadowRoot.querySelectorAll(".upcart-public-component-product-tile, .upcart-internal-component-product-tile");
  tiles.forEach((tile) => {
    const link = tile.querySelector('a[href*="/products/shipping-protection"]');
    if (!link) return;
    const qty = tile.querySelector(
      ".upcart-public-component-product-tile__quantity-selector, .upcart-internal-component-product-tile__quantity-selector"
    );
    if (qty) qty.style.display = "none";
  });
}

// Temporarily hide UpCart's "Subscribe & Save" subscription button on ALL products
// while subscriptions are paused (selling plans are NOT deleted).
// To re-enable: remove this function, the observer below, and their two call sites.
function hideUpcartSubscribeButton(shadowRoot) {
  if (!shadowRoot) return;
  try {
    const labels = ["subscribe & save", "subscribe and save"];
    const candidates = shadowRoot.querySelectorAll("button, a, [role='button']");
    candidates.forEach((el) => {
      const text = (el.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
      if (labels.some((label) => text === label || text.startsWith(label))) {
        el.style.setProperty("display", "none", "important");
      }
    });
  } catch (err) {
    // silent
  }
}

// UpCart re-renders its shadow DOM on cart changes, so watch for re-renders and re-hide.
function observeUpcartForSubscribeButton(shadowRoot) {
  if (!shadowRoot || shadowRoot.__subscribeHiderObserver) return;
  try {
    const observer = new MutationObserver(() => hideUpcartSubscribeButton(shadowRoot));
    observer.observe(shadowRoot, { childList: true, subtree: true });
    shadowRoot.__subscribeHiderObserver = observer;
    hideUpcartSubscribeButton(shadowRoot);
  } catch (err) {
    // silent
  }
}

// Energy drinks ship at the UPS rate and never get free shipping or promo codes.
// Tell the shopper in the drawer with a note above the discount row whenever the
// cart has an energy drink. The free-shipping bar itself stays generic.
const ENERGY_DRINK_NOTE = "Energy drinks ship at the carrier rate and are excluded from free shipping and promo codes. Everything else in your cart still qualifies.";
let energyDrinkCart = null;

function isEnergyDrinkItem(item) {
  return item && item.product_type === "Energy Drinks";
}

function injectEnergyDrinkStyles(shadowRoot) {
  if (!shadowRoot || shadowRoot.getElementById("upcart-energy-drink-style")) return;
  const style = document.createElement("style");
  style.id = "upcart-energy-drink-style";
  style.textContent = `
    .upcart-energy-note {
      margin: 0 0 10px;
      padding: 8px 12px;
      background: #fff8e6;
      border: 1px solid #f3d58a;
      border-radius: 6px;
      font-size: 12px;
      line-height: 1.4;
      color: #5c4400;
    }
    .upcart-energy-note p { margin: 0; }
  `;
  shadowRoot.appendChild(style);
}

function renderEnergyDrinkNotes(shadowRoot) {
  if (!shadowRoot) return;
  try {
    injectEnergyDrinkStyles(shadowRoot);

    if (!energyDrinkCart && !renderEnergyDrinkNotes.fetching) {
      renderEnergyDrinkNotes.fetching = true;
      fetch("/cart.js")
        .then((res) => res.json())
        .then((cart) => {
          if (!energyDrinkCart) energyDrinkCart = cart;
          renderEnergyDrinkNotes(shadowRoot);
        })
        .catch(() => {});
    }

    const items = (energyDrinkCart && energyDrinkCart.items) || [];
    const hasEnergyDrink = items.some(isEnergyDrinkItem);
    const existing = shadowRoot.querySelector(".upcart-energy-note");

    if (!hasEnergyDrink) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;

    const anchor = shadowRoot.querySelector(".upcart-public-cart-summary, .upcart-internal-cart-summary");
    const footer = shadowRoot.querySelector(".styles_Footer__checkoutButton__");
    if (!anchor && !footer) return;

    const note = document.createElement("div");
    note.className = "upcart-energy-note";
    note.innerHTML = "<p>" + ENERGY_DRINK_NOTE + "</p>";
    if (anchor) anchor.parentNode.insertBefore(note, anchor);
    else footer.prepend(note);
  } catch (err) {
    // silent
  }
}

// UpCart re-renders its shadow DOM on cart changes, so put the notes back after each render.
function observeUpcartForEnergyDrinks(shadowRoot) {
  if (!shadowRoot || shadowRoot.__energyDrinkObserver) return;
  try {
    const observer = new MutationObserver(() => renderEnergyDrinkNotes(shadowRoot));
    observer.observe(shadowRoot, { childList: true, subtree: true });
    shadowRoot.__energyDrinkObserver = observer;
    renderEnergyDrinkNotes(shadowRoot);
  } catch (err) {
    // silent
  }
}

window.upcartModifyCart = (cart) => {
  energyDrinkCart = cart;

  try {
    // console.log("Executing upcartModifyCart...");
    // fetchUpdatedUpsellSection();
    let upCart = document.querySelector("#upCart");
    if (!upCart || !upCart.shadowRoot) {
      console.error("Error: #upCart or its shadowRoot not found.");
    }

    if (upCart && upCart.shadowRoot) {
      injectShippingProtectionStyles(upCart.shadowRoot);
      injectRewardsMinHeightStyles(upCart.shadowRoot);
      injectFirstCartItemSpacing(upCart.shadowRoot);
      hideShippingProtectionQtyFallback(upCart.shadowRoot);
      observeUpcartForSubscribeButton(upCart.shadowRoot);
      observeUpcartForEnergyDrinks(upCart.shadowRoot);
      renderEnergyDrinkNotes(upCart.shadowRoot);
    }

    if(cart.item_count == 0){
      upCart.shadowRoot.querySelector("#UpcartPopup").classList.add("upcart-empty")
    }
    else{
      upCart.shadowRoot.querySelector("#UpcartPopup").classList.remove("upcart-empty")
    }
    
    // Helper function to wait for an element inside a shadow DOM
    function waitForYouSaveContainer(upCart, timeout = 8000) {
      return new Promise((resolve, reject) => {
        const start = Date.now();
    
        function check() {
          const found = upCart?.shadowRoot?.querySelector("[SIDECART-YOU-SAVE-IN-UPCART]");
          if (found) return resolve(found);
          if (Date.now() - start > timeout) return;
          setTimeout(check, 60); // Try again in 60ms
        }
        check();
      });
    }
    
    // Usage:
    (async function () {
      // Make sure upCart is defined and has a shadowRoot
      if (!window.upCart || !window.upCart.shadowRoot) {
        console.error("upCart or shadowRoot not available!");
        return;
      }
    
      let youSaveContainer;
      try {
        youSaveContainer = await waitForYouSaveContainer(window.upCart);
      } catch (e) {
        console.error(e.message);
        return;
      }
    
      // --- Your original logic here, now running when the element exists ---
      let youSavedElement = youSaveContainer.querySelector(".you-saved");
      let totalPriceElement = youSaveContainer.querySelector(".cart-total-price");
    
      if (!youSavedElement || !totalPriceElement) {
        console.error("Error: .you-saved or .cart-total-price not found.");
        return;
      }
      try {
        let moneyFormat = youSaveContainer.dataset.money_format;
        totalPriceElement.innerHTML = moneyFormat.replace("{{amount}}", (cart.total_price / 100));
        // console.log("Updated total price:", totalPriceElement.innerHTML);
      } catch (error) {
        //console.error("Error updating total price:", error);
      }
    
      // console.log("Executing savings calculation...");
      let totalSavings = 0;
      let savingsElements = upCart.shadowRoot.querySelectorAll(".upcart-cart-body .upcart-product-savings");
    
      if (savingsElements) {
        savingsElements.forEach(el => {
          try {
            let text = el.innerText.match(/[\d,.]+/);
            if (text) {
              let value = parseFloat(text[0]);
              if (!isNaN(value)) {
                totalSavings += value;
                // console.log("Extracted saving:", value, "Running total:", totalSavings);
              }
            }
          } catch (error) {
            //console.error("Error processing savings element:", el, error);
          }
        });
    
        let formattedDiscount = totalSavings.toFixed(2);
        // console.log("Total savings:", formattedDiscount);
    
        try {
          if (youSaveContainer) {
            youSaveContainer.querySelector(".sidecart-you-save-wrapper").style.display = formattedDiscount < 1 ? "none" : "flex";
            youSavedElement.innerHTML = youSaveContainer.dataset.money_format.replace("{{amount}}", formattedDiscount);
            // console.log("Updated savings display:", youSavedElement.innerHTML);
          }
        } catch (error) {
          //console.error("Error updating savings display:", error);
        }
      }
    })();    

  } catch (error) {
    //console.error("Critical error in upcartModifyCart execution:", error);
  }

  // This timeout should always execute
  setTimeout(function () {
    let upCart = document.querySelector("#upCart");
    let elements = upCart?.shadowRoot?.querySelectorAll(".upcart-rewards-tier-circle");

    if (!elements || elements.length === 0) {
      // Rewards tier circles only exist when the UpCart rewards bar is rendered; nothing to do.
      return;
    }

    elements.forEach(el => {
      try {
        if (el.style.fill === "rgb(212, 212, 212)") {
          el.querySelector(".upcart-rewards-tier-icon").style.opacity = 1;
        } else {
          el.querySelector(".upcart-rewards-tier-icon").style.opacity = 0;
        }
      } catch (error) {
        //console.error("Error processing rewards tier circle:", error);
      }
    });
  }, 600);

  //addObserverForUpsellArrows(document.querySelector("#upCart"))

};



window.reviewsIndex = null;

function getRandomNumber(min, max) {
  // First call – generate random number once
  if (window.reviewsIndex === null) {
    window.reviewsIndex = Math.floor(Math.random() * (max - min + 1)) + min;
  } else {
    // Increment and wrap around if needed
    window.reviewsIndex++;
    if (window.reviewsIndex > max) {
      window.reviewsIndex = min;
    }
  }
  return window.reviewsIndex;
}

function handleUpcartOpened() {
  try {
    const upCart = document.querySelector("#upCart");

    if (upCart && upCart.shadowRoot) {
      injectShippingProtectionStyles(upCart.shadowRoot);
      injectRewardsMinHeightStyles(upCart.shadowRoot);
      injectFirstCartItemSpacing(upCart.shadowRoot);
      hideShippingProtectionQtyFallback(upCart.shadowRoot);
      observeUpcartForSubscribeButton(upCart.shadowRoot);
      observeUpcartForEnergyDrinks(upCart.shadowRoot);
      renderEnergyDrinkNotes(upCart.shadowRoot);
      const upcartPopup = upCart.shadowRoot.querySelector("#UpcartPopup");

      if (upcartPopup) {
        upcartPopup.classList.add("upcart--redesign");

        if (navigator.userAgent.indexOf("Mac OS X") !== -1) {
          upcartPopup.classList.add("mac-device");
        } else {
          upcartPopup.classList.add("windows-device");
        }

        updateCartBodyHeight();
        // addObserverForUpsellArrows(upCart);
      } else {
        // console.error("Element #UpcartPopup not found inside shadowRoot.");
      }
    } else {
      // console.error("#upCart or its shadowRoot not found.");
    }
  } catch (error) {
    console.error("An error occurred:", error);
  }

  try {
    const upCart = document.querySelector("#upCart");
    const shadowRoot = upCart?.shadowRoot;

    if (!shadowRoot) {
      console.warn("Shadow root not found on #upCart.");
      return;
    }

    const reviewContainer =
      shadowRoot.querySelector(".upcart-recommendation-module .empty-cart-custom [SIDECART-REVIEWS-IN-UPCART]") ||
      shadowRoot.querySelector(".styles_CartPreview__empty__ div .empty-cart-custom [SIDECART-REVIEWS-IN-UPCART]") ||
      shadowRoot.querySelector(".upcart-cart-body [SIDECART-REVIEWS-IN-UPCART]");

    if (reviewContainer && reviewContainer.dataset.total_blocks) {
      const maxLength = parseInt(reviewContainer.dataset.total_blocks) - 1;
      const randomNum = getRandomNumber(0, maxLength);

      reviewContainer.querySelectorAll(".sidecart-review-item").forEach((el, index) => {
        el.style.display = index === randomNum ? "block" : "none";
      });
    }

    const rewardIcons = shadowRoot.querySelectorAll(".upcart-rewards-tier-icon");

    rewardIcons.forEach((el) => {
      el.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none"><path d="M2.64099 6L0 3.15593L0.660247 2.44491L2.64099 4.57796L6.89205 0L7.55229 0.711019L2.64099 6Z" fill="white"/></svg>`;
    });
  } catch (error) {
    console.error("Error while updating upcart content:", error);
  }
}

window.addEventListener('aftersell-upcart:public-events:cart-opened', handleUpcartOpened);

window.reviewSliderElementUp = null;
window.appendReviewSliderElementup = function () {
  const checkDivReviewUp = setInterval(() => {
    try {
      const upCart = document.querySelector("#upCart");
      if (!upCart || !upCart.shadowRoot) return;
    
      // Handle empty-cart-custom creation if needed
      const emptyDiv = upCart.shadowRoot.querySelector(".upcart-recommendation-module  ") || 
        upCart.shadowRoot.querySelector(".styles_CartPreview__empty__ div ") ||
        upCart.shadowRoot.querySelector(".upcart-cart-body");
      
      if (emptyDiv && !emptyDiv.querySelector(".empty-cart-custom")) {
        const emptyEl = document.createElement("div");
        emptyEl.className = "empty-cart-custom";
        emptyDiv.append(emptyEl);
      }
    
      // Where to put reviews slider
      const existing = upCart.shadowRoot.querySelectorAll("[SIDECART-REVIEWS-IN-UPCART]");
      const bodyTarget =
        upCart.shadowRoot.querySelector(".upcart-recommendation-module .empty-cart-custom ") || 
        upCart.shadowRoot.querySelector(".styles_CartPreview__empty__ div .empty-cart-custom") ||
        upCart.shadowRoot.querySelector(".upcart-cart-body");
    
      // Only proceed if footer review slider is available and not already present in upcart
      if ((document.querySelectorAll(".shopify-section-group-footer-group [SIDECART-REVIEWS-IN-UPCART]").length > 0 || window.reviewSliderElementUp) && existing.length === 0 && bodyTarget) {
        // Use cached element if available
        if (window.reviewSliderElementUp) {
          bodyTarget.append(window.reviewSliderElementUp);
        } else {
          // Otherwise pick from DOM, cache, and append
          const elements = document.querySelectorAll(".shopify-section-group-footer-group [SIDECART-REVIEWS-IN-UPCART]");
          if (elements.length > 0) {
            window.reviewSliderElementUp = elements[elements.length - 1];
            bodyTarget.append(window.reviewSliderElementUp);
            window.reviewSliderElementUp.style.display = "block";
          }
        }
      }
    } catch (err) {
      // Suppressed: console.error("Error in appendReviewSliderElementup:", err);
    }
  }, 200);
};
window.appendReviewSliderElementup();

window.youSaveElementUp = null;
window.appendYouSaveElementup = function () {
  const checkDivYouSaveUp = setInterval(() => {
    try {
      const upCart = document.querySelector("#upCart");
      if (!upCart || !upCart.shadowRoot) return;

      if(upCart.shadowRoot.querySelector("styles_CartPreview__empty__")) return;
      const existing = upCart.shadowRoot.querySelectorAll("[SIDECART-YOU-SAVE-IN-UPCART]");
      // if(existing.closest(".styles_CartPreview__empty__")){
      //   return;
      // }
      // const footer = upCart.shadowRoot.querySelector(".styles_Footer__checkoutButton__");

      const footer = upCart.shadowRoot.querySelector(".styles_Footer__checkoutButton__");

      if ((document.querySelectorAll("[SIDECART-YOU-SAVE-IN-UPCART]").length > 0 || window.youSaveElementUp) && existing.length === 0) {
        if (window.youSaveElementUp && footer) {
          footer.prepend(window.youSaveElementUp);
          // clearInterval(checkDivYouSaveUp);
        } else if (footer) {
          const elements = document.querySelectorAll("[SIDECART-YOU-SAVE-IN-UPCART]");
          if (elements.length > 0) {
            window.youSaveElementUp = elements[elements.length - 1];
            footer.prepend(window.youSaveElementUp);
            footer.querySelector("[SIDECART-YOU-SAVE-IN-UPCART]").style.display = "block";
            // clearInterval(checkDivYouSaveUp);
          }
        }
      }
    } catch (err) {
      // console.error("Error in appendYouSaveElementup:", err);
    }
  }, 200);
};
window.appendYouSaveElementup();

window.appendSidecartValueProp = function() {
  const checkDivSidecartValueProp = setInterval(() => {
    const upCart = document.querySelector("#upCart");
    if (!upCart || !upCart.shadowRoot) return;
  
    // Handle empty-cart-custom creation if neededß
    const emptyDiv = upCart.shadowRoot.querySelector(".upcart-recommendation-module ") || upCart.shadowRoot.querySelector(".styles_CartPreview__empty__ div");
    if (emptyDiv && !emptyDiv.querySelector(".empty-cart-custom")) {
      const emptyEl = document.createElement("div");
      emptyEl.className = "empty-cart-custom";
      emptyDiv.prepend(emptyEl);
    }

    if(emptyDiv){
      if(!emptyDiv.querySelector(".sidecart-value-prop")){
        const bodyTarget = upCart.shadowRoot.querySelector(".upcart-recommendation-module .empty-cart-custom") || upCart.shadowRoot.querySelector(".styles_CartPreview__empty__ div .empty-cart-custom");      
        let sidecartValueProp = document.querySelector(".sidecart-value-prop");
        let upCartElement = document.querySelector("#upCart");
        let upCartElementClosest = upCartElement.closest("body");
        if (sidecartValueProp) {
          let clonedContent = sidecartValueProp.cloneNode(true);
          clonedContent.classList.add("cloned");
          bodyTarget.appendChild(clonedContent);
        }
      }
    }
  }, 200);
}
window.appendSidecartValueProp();

window.addEventListener('load', updateCartBodyHeight);
window.addEventListener('resize', updateCartBodyHeight);

function updateCartBodyHeight() {
  const upCart = document.querySelector("#upCart");

  if (upCart && upCart.shadowRoot) {
    const upcartShadowRoot = upCart.shadowRoot;
    const footer = upcartShadowRoot.querySelector('.upcart-footer');
    const cartBody = upcartShadowRoot.querySelector('.upcart-cart-body');

    if (footer && cartBody) {
      // Calculate footer height + 20px for margin
      const footerHeight = footer.getBoundingClientRect().height + 20;
      const availableHeight = window.innerHeight - footerHeight;

      // Apply the calculated height directly
      cartBody.style.maxHeight = `${availableHeight}px`;

      // Log applied height
      // console.log("Setting cartBody max-height to:", availableHeight + "px");
      // console.log("Computed style now is:", getComputedStyle(cartBody).maxHeight);
    }
  }
}




// ── Guarantee badge injection into UpCart Shadow DOM ──
window.appendGuaranteeToUpcart = function () {
  var injected = false;
  var checkInterval = setInterval(function () {
    try {
      var upCart = document.querySelector("#upCart");
      if (!upCart || !upCart.shadowRoot) return;

      var footer = upCart.shadowRoot.querySelector(".styles_Footer__checkoutButton__");
      if (!footer) return;

      // Don't double-inject
      if (upCart.shadowRoot.querySelector(".upcart-guarantee-strip")) {
        injected = true;
        clearInterval(checkInterval);
        return;
      }

      // Inject scoped styles into shadow root once
      if (!upCart.shadowRoot.querySelector("#upcart-guarantee-style")) {
        var style = document.createElement("style");
        style.id = "upcart-guarantee-style";
        style.textContent = [
          ".upcart-guarantee-strip{display:flex;align-items:center;justify-content:center;gap:6px;",
          "padding:8px 12px;margin-bottom:8px;background:#f4f9f4;border:1px solid #c8e6c9;",
          "border-radius:6px;font-size:12px;color:#2e5e2e;text-align:center;font-family:inherit;}",
          ".upcart-guarantee-strip svg{flex-shrink:0;color:#388e3c;}",
          ".upcart-guarantee-strip a{color:#2e5e2e;text-decoration:underline;}"
        ].join("");
        upCart.shadowRoot.appendChild(style);
      }

      // Create the badge element
      var badge = document.createElement("div");
      badge.className = "upcart-guarantee-strip";
      badge.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>' +
        '<span>30-Day Money-Back Guarantee &mdash; <a href="/pages/guarantee">Learn more</a></span>';

      footer.prepend(badge);
      injected = true;
      clearInterval(checkInterval);
    } catch (err) {
      // silent
    }
  }, 200);
};
window.appendGuaranteeToUpcart();

// Re-inject when cart is opened (UpCart may re-render shadow DOM)
window.addEventListener("aftersell-upcart:public-events:cart-opened", function () {
  setTimeout(function () {
    var upCart = document.querySelector("#upCart");
    if (upCart && upCart.shadowRoot) {
      upCart.shadowRoot.querySelector(".upcart-guarantee-strip") && (function(){})();
      // Remove old badge so it can be re-injected fresh
      var old = upCart.shadowRoot.querySelector(".upcart-guarantee-strip");
      if (old) old.remove();
    }
    window.appendGuaranteeToUpcart();
  }, 300);
});
